
import Clarity from '@microsoft/clarity';
import { useEffect, useState } from "react";
import { CLARITY_PROJECT_ID } from '../../../../project_config';
import { api } from "../../../../utils/api";
import CatalogListGrid from "../../../common/catalog/CatalogListGrid";
import { catalogPageParams } from "../../../common/catalog/catalogPageSize";
import CatalogListSection from "../../../common/catalog/CatalogListSection";
import Skeleton from "../../../common/loading/Skeleton";
import Paginator from "../../../common/paginator/Paginator";
import Episode from "../../../home/tag/episode/Episode";
import { expertiseGridClassName } from "../../../common/expertise/expertiseGrid";
import Expertise from "../../../home/tag/expertise/Expertise";
import Workshop from "../../../home/tag/workshop/Workshop";
import Webinar from "./Webinar";

export default function TagSection({ tagId, isDesktop, onReceiveTitle }) {
	Clarity.init(CLARITY_PROJECT_ID);
	const [title, setTitle] = useState('');
	const [category, setCategory] = useState('');
	const [workshops, setWorkshops] = useState([]);
	const [webinars, setWebinars] = useState([]);
	const [episodes, setEpisodes] = useState([]);
	const [expertises, setExpertises] = useState([]);
	const [page, setPage] = useState(1);
	const [maxPageNum, setMaxPageNum] = useState(1);
	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');

	useEffect(() => {
		fetchTag();
	}, []);

	useEffect(() => {
		fetchTag();
	}, [page]);

	function fetchTag() {
		if (isLoading) {
			return;
		}
		setIsLoading(true);
		let tagIdParam = tagId ? tagId : '';
		api.homeFetchTag({
			tag_id: tagIdParam,
			...catalogPageParams(page),
		}).then((result) => {
			setTitle(result['title']);
			setCategory(result['category']);
			setWorkshops(result['workshops']);
			setWebinars(result['webinars']);
			setEpisodes(result['episodes']);
			setExpertises(result['expertises']);
			setMaxPageNum(result['max_page']);
			setIsLoading(false);
			onReceiveTitle(result['title']);
		}).catch((err) => {
			setIsLoading(false);
			if (err && err.data) {
				setErrorMessage(err.data.message);
			}
		});
	}

	const pagination =
		maxPageNum >= 2 ? (
			<Paginator
				currentPage={page}
				maxPageNum={maxPageNum}
				isLoading={isLoading}
				onChange={(newPage) => {
					setPage(newPage);
				}}
			/>
		) : null;

	return (
		<CatalogListSection pagination={pagination}>
			<div className="font-Vazir-700 text-[16px] text-[#666666]">
				{title}
			</div>
			<div className="spacer p-[10px]"></div>
			{isLoading && <Skeleton variant="grid" type={category || "workshop"} count={8} />}
			{!isLoading && (
				<>
					{category === "workshop" && (
						<CatalogListGrid isDesktop={isDesktop}>
							{workshops.map((workshop) => (
								<Workshop key={workshop.id} workshop={workshop} />
							))}
						</CatalogListGrid>
					)}
					{category === "webinar" && (
						<CatalogListGrid isDesktop={isDesktop}>
							{webinars.map((webinar) => (
								<Webinar key={webinar.id} webinar={webinar} />
							))}
						</CatalogListGrid>
					)}
					{category === "episode" && (
						<CatalogListGrid isDesktop={isDesktop}>
							{episodes.map((episode) => (
								<Episode key={episode.id} episode={episode} />
							))}
						</CatalogListGrid>
					)}
					{category === "expertise" && (
						<div className={expertiseGridClassName(isDesktop)}>
							{expertises.map((expertise, index) => (
								<Expertise
									key={expertise.id}
									expertise={expertise}
									isDesktop={isDesktop}
									index={index}
								/>
							))}
						</div>
					)}
				</>
			)}
			{errorMessage && (
				<div className="text-center font-Vazir-400 text-[#cc0000]">{errorMessage}</div>
			)}
		</CatalogListSection>
	)
}
